import { faTableColumns } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons';

export const actions: IAction[] = [
  {
    context: 'citizenjournalnotes',
    id: 'ColumnChooser',
    displayName: 'Kolonner',
    icon: faTableColumns,
    isVisible: selectedItemsCount => selectedItemsCount === 0,
  },
  {
    context: 'citizen',
    id: 'ShowLink',
    displayName: 'Vis link',
    action: (selectedEntries, selectedRootIds) => {
      let preText = '';
      let text = '';
      selectedEntries.forEach((entityId, i) => {
        const link = `${window.location.href}/note/view/${entityId.replace(/[{}]/g, '')}`;
        text += `${preText}${link}`;
        preText = '\r\n\r\n';
      });
      // eslint-disable-next-line no-alert
      window.prompt('Kopiér link til udklipsholder: Ctrl+C, Enter', text);
    },
    icon: faExternalLink,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 10 ? 'Antallet af valgte elementer må ikke overstige 10' : ''),
    showOnUniverseAction: true,
  },
];
